export enum SupportUserAvailabilityOverride {
  Active = "active",
  Inactive = "inactive",
}
